import { useSetRecoilState } from 'recoil';

import {
  selectedAccountsPerformanceYearState,
  selectedActivationsByProfileYearState,
  selectedBigNumbersYearState,
  selectedCustomersActivationYearState,
} from './atom';
import { changeHomeValueVisibility } from './selector';

export const useHomeActions = () => {
  const setHomeValueVisibility = useSetRecoilState(changeHomeValueVisibility);
  const setSelectedBigNumbersYearState = useSetRecoilState(selectedBigNumbersYearState);
  const setSelectedAccountsPerformanceYearState = useSetRecoilState(
    selectedAccountsPerformanceYearState
  );
  const setSelectedCustomersActivationYearState = useSetRecoilState(
    selectedCustomersActivationYearState
  );
  const setSelectedActivationsByProfileYearState = useSetRecoilState(
    selectedActivationsByProfileYearState
  );

  const updateHomeValueVisibility = (visible: boolean) => {
    setHomeValueVisibility(visible);
  };

  const setSelectedBigNumbersYear = (year: number | string) =>
    setSelectedBigNumbersYearState(year.toString());

  const setSelectedAccountsPerformanceYear = (year: number | string) =>
    setSelectedAccountsPerformanceYearState(year.toString());

  const setSelectedCustomersActivationYear = (year: number | string) =>
    setSelectedCustomersActivationYearState(year.toString());

  const setSelectedActivationsByProfileYear = (year: number | string) =>
    setSelectedActivationsByProfileYearState(year.toString());

  return {
    updateHomeValueVisibility,
    setSelectedBigNumbersYear,
    setSelectedAccountsPerformanceYear,
    setSelectedCustomersActivationYear,
    setSelectedActivationsByProfileYear,
  };
};
